"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDateField = void 0;
const date_field_1 = require("../../../components/date-field/date-field");
const form_field_1 = require("./form-field");
/**
 * @deprecated
 *
 * Use FormLocalDateField instead.
 */
exports.FormDateField = form_field_1.formFieldFactory(date_field_1.DateField);
//# sourceMappingURL=form-date-field.js.map